let selects

export function Selects(context = document) {
    const selectEls = context.querySelectorAll('.js-select, .js-select-submit')
    selects = Array.from(selectEls)
    if (selects.length) {
        import('choices.js')
            .then((m) => m.default)
            .then((Choices) => {
                selects = selects.map((el) => setupSelect(Choices, el))
            })
    }

    return selects
}

function setupSelect(Choices, el) {
    if (el.classList.contains('js-select-submit')) {
        el.addEventListener('change', function (evt) {
            const form = evt.target.closest('form')
            form.submit()
        })
    }

    const options = {
        searchEnabled: false,
        itemSelectText: '',
        removeItemButton: el.multiple,
        shouldSort: false,
        noChoicesText: 'All events have been selected',
        callbackOnCreateTemplates: function (template) {
            var classNames = this.config.classNames
            return {
                containerInner: () => {
                    return template(
                        `<div class="${classNames.containerInner}">
                            <div class="choices__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M17.3 8.3a1 1 0 1 1 1.4 1.4l-1.4-1.4ZM12 15l.7.7-.7.7-.7-.7.7-.7ZM5.3 9.7a1 1 0 0 1 1.4-1.4L5.3 9.7Zm13.4 0-6 6-1.4-1.4 6-6 1.4 1.4Zm-7.4 6-6-6 1.4-1.4 6 6-1.4 1.4Z"/>
                                </svg>
                            </div>
                        </div>`
                    )
                }
            }
        }
    }

    return new Choices(el, options)
}
